module.exports = __webpack_public_path__ + "img/T6-D-rc_2.e40fc9e3.png";